import React from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { DateTimePicker } from '@progress/kendo-react-dateinputs'
import { getDateTimeFormat } from 'utils/date'

interface DateTimeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const DateTimeFilter: React.FC<DateTimeFilterProps> = ({ filter, onFilterChange }) => {
  const selectValue = filter.value || null
  const dateFormatType = getDateTimeFormat()

  return (
    <DateTimePicker
      value={selectValue}
      onChange={(event) => {
        if (event.value) {
          onFilterChange.call(undefined, {
            nextFilter: { ...filter, value: event.value },
          })
        }
      }}
      format={dateFormatType}
    />
  )
}
